import { Component, ElementRef, Input, ViewChild, OnDestroy, signal } from "@angular/core";
import { ControlContainer, NgModelGroup } from "@angular/forms";
import { MetadataInputSelectComponent } from "./metadata-input-select.component";
import { Utilities } from "@tylertech/shared-module";
import { PopoverComponent } from "@tylertech/forge";
import { RepositoryFormData } from "../../../../interfaces";

@Component({
    selector: "metadata-input-multi-select",
    templateUrl: "./metadata-input-multi-select.tmpl.html",
    viewProviders: [{ provide: ControlContainer, useExisting: NgModelGroup }],
    standalone: false
})
export class MetadataInputMultiSelectComponent extends MetadataInputSelectComponent implements OnDestroy
{
    @Input() datacontroller: RepositoryFormData;

    @ViewChild("popover") popover: PopoverComponent;
    @ViewChild("popupContent") popupContent: any;
    @ViewChild("searchFilter") searchFilter: ElementRef;

    opening: boolean = false;

    multiSelectListCard: Element;

    ascendingSort = true;

    private multiScrollHandler = (event: Event): void => this.triggerScroll(event);

    ngOnDestroy(): void
    {
        if (this.popover?.open)
            this.modelForTracking.$recalculating = false;

        this.multiSelectListCard?.removeEventListener("scroll", this.multiScrollHandler);
        this.popover = null;
        this.popupContent = null;
        this.searchFilter = null;
        super.ngOnDestroy();
    }

    openPopup(open: boolean): void
    {
        this.opening = true;
        if (open)
            this.popover.open = true;
        this.opening = false;
        const self = this;
        requestAnimationFrame(() =>
        {
            const id = `mlt-${this.popupId}`;

            if (self.forCellEdit)
            {
                return;
            }
            const popup: any = document.querySelector(`#${this.getPopupId(id)}`);
            const popupTarget: any = document.querySelector(`#${id}`);
            const targetBounds = popupTarget.getBoundingClientRect();
            if (popup)
            {
                popup.style.width = `${targetBounds.width + 30}px`;
                this.searchFilter.nativeElement.focus();

                if (!this.multiSelectListCard)
                {
                    this.multiSelectListCard = document.querySelector(`#${this.popupId}MultiSelectListCard`).querySelector("forge-list");
                    if (!Utilities.IsNullOrUndefined(this.multiSelectListCard))
                    {
                        this.multiSelectListCard.addEventListener("scroll", this.multiScrollHandler);
                    }
                }
            }
        });
    }

    triggerScroll(event): void
    {
        this.$metadataInputSelectService.fireMultiSelectScrollListener(this.popupContent.nativeElement.id, event);
    }

    textContainerKeydown($event: any): void
    {
        if ($event.key === "ArrowDown")
        {
            this.openPopup(true);
            $event.preventDefault();
            $event.stopPropagation();
        }

        if($event.code === "NumpadAdd")
        {
            $event.preventDefault();
            this.onKeyDown($event);
        }
    }

    closePopup(): void
    {
        if (!this.opening)
        {
            this.$metadataInputSelectService.fireMultiSelectChangeListener(`multi-select-${this.popupId}`);
        }

        const target: any = document.querySelector(`#${this.getIdFromPopupId(this.popupContent.nativeElement.id)}`);
        target.focus();

        if (this.popover.open)
        {
            this.popover.open = false;
        }

        this.multiSelectListCard?.removeEventListener("scroll", this.multiScrollHandler);
        this.multiSelectListCard = null;

        this.sortOptions(this.ascendingSort);
        this.maybeRunSave();
        this.maybeRunRecalculate();
    }

    trapTab(e: KeyboardEvent): void
    {
        if (e.key === "Tab" && e.shiftKey)
        {
            this.closePopup();
        }
    }

    sort(): void
    {
        this.ascendingSort = !this.ascendingSort;
        this.sortOptions(this.ascendingSort);
    }

    get isAscendingSort(): boolean
    {
        return this.ascendingSort;
    }

    closeButtonKeyDown(e: KeyboardEvent): void
    {
        if (e.key === "Tab" && !e.shiftKey)
        {
            e.preventDefault();
            this.closePopup();
        }
    }

    private getIdFromPopupId(popupId): any
    {
        if (popupId.includes("multi-select-"))
            return popupId.replace("multi-select-", "mlt-");
        else return popupId;
    }

    getPopupId(id): any
    {
        if (id.includes("mlt-")) return id.replace("mlt-", "multi-select-");
        else return id;
    }

    togglePopover($event: any): void
    {
        if ($event.detail?.newState === "open")
            this.modelForTracking.$recalculating = true;
        if ($event.detail?.newState === "closed")
            this.closePopup();
    }

    maybeRunSave(): void
    {
        this.modelForTracking.$recalculating = false;
        if (this.modelForTracking.$saveAfterRecalculate)
            this.$metadataEventService.fireSaveAfterRecalculateListener();
    }

    maybeRunRecalculate(): void
    {
        if (!this.modelForTracking.$recalculateAfterRecalculate)
            return;
        this.$metadataEventService.fireRecalculateWorkingListeners(
        {
            ShowLoading: false,
            Recalculating: false,
        },
        false);
    }

    get modelForTracking(): any
    {
        if (this.datacontroller && this.datacontroller.OtherEntities && this.datacontroller.OtherEntities[this.metadataModel.$$TypeName] && this.datacontroller.OtherEntities[this.metadataModel.$$TypeName].length > 0)
            return this.datacontroller.Entity;
        return this.metadataModel;
    }
}
